import { Cog8ToothIcon } from '@heroicons/react/24/outline'
import { createElement } from 'react'
import type { Menu } from '@/types'

export const menu: Menu[] = [
  { name: 'Home', href: '/' },
  {
    name: 'Data',
    href: '',
    children: [
      { name: 'Daily Snapshot', href: '/statistics/daily-snapshot', path: ['Statistics', 'Daily Snapshot'] },
      { name: 'Vehicle Value', href: '/statistics/vehicle-value', path: ['Statistics', 'Vehicle Value'] },
      { name: 'Decode Results', href: '/statistics/decode', path: ['Statistics', 'Decode Results'] },
      { name: 'Vehicle Generation', href: '/data/vehicle-generation', path: ['Data', 'Vehicle Generation'] },
    ],
  },
  {
    name: 'Cruz',
    href: '',
    children: [
      { name: 'Users', href: '/cruz/users', path: ['Cruz', 'Users'] },
      { name: 'Private Vehicles', href: '/cruz/private-vehicles', path: ['Cruz', 'Private Vehicles'] },
      { name: 'Contact Us Messages', href: '/cruz/contact-us-messages', path: ['Cruz', 'Contact Us Messages'] },
      {
        name: 'Dealer Contact Messages',
        href: '/cruz/dealer-contact-messages',
        path: ['Cruz', 'Dealer Contact Messages'],
      },
      { name: 'Feedback', href: '/cruz/feedback', path: ['Cruz', 'Feedback'] },
      { name: 'Saved Vehicles', href: '/cruz/saved-vehicles', path: ['Cruz', 'Saved Vehicles'] },
      { name: 'Saved Searches', href: '/cruz/saved-searches', path: ['Cruz', 'Saved Searches'] },
    ],
  },
  {
    name: 'Lead',
    href: '',
    children: [{ name: 'Vehicle Leads', href: '/lead/vehicle-leads', path: ['Lead', 'Vehicle Leads'] }],
  },
  {
    name: 'Carsforsale Import',
    href: '',
    children: [
      { name: 'Locations', href: '/carsforsale-import/locations', path: ['Carsforsale Import', 'Locations'] },
      {
        name: 'Ignored Locations',
        href: '/carsforsale-import/ignored-locations',
        path: ['Carsforsale Import', 'Ignored Locations'],
      },
      { name: 'Vehicles', href: '/carsforsale-import/vehicles', path: ['Carsforsale Import', 'Vehicles'] },
    ],
  },
  {
    name: 'Log',
    href: '',
    children: [
      { name: 'Ask Cruz AI', href: '/log/ask-cruz-ai', path: ['Log', 'Ask Cruz Ai'] },
      { name: 'Recently Viewed', href: '/log/recently-viewed', path: ['Cruz', 'Recently Viewed'] },
      { name: 'Vehicle Search', href: '/log/vehicle-search', path: ['Log', 'Vehicle Search'] },
      { name: 'VDP Views', href: '/log/vdp-views', path: ['Log', 'VDP Views'] },
      { name: 'Errors', href: '/log/errors', path: ['Log', 'Errors'] },
      { name: 'Dataone Import', href: '/log/dataone-import', path: ['Log', 'Dataone Import'] },
      { name: 'Carsforsale Import', href: '/log/carsforsale-import', path: ['Log', 'Carsforsale Import'] },
    ],
  },
  {
    name: 'Settings',
    href: '/settings',
    icon: createElement(Cog8ToothIcon, { className: 'w-5 h-5' }),
  },
]

export const defaultPostHeader = {
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
}

export const photoBaseUrl = {
  s3: 'https://cruzs3.s3.amazonaws.com',
  // cdn: 'https://d3rdub4fa9i2b.cloudfront.net'
  cdn: 'https://img.cruz.com',
}

export const pages = {
  // auth
  signIn: { name: 'Sign In', href: '/auth/sign-in' },
  forgotPassword: { name: 'Forgot Password?', href: '/auth/forgot-password' },
  newPassword: { name: 'New Password?', href: '/auth/new-password' },
}

export const DateTimeFormat = 'YYYY-MM-DD h:mm A'
